module.exports = __webpack_public_path__ + "static/img/taillight.5ccb5d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/work/land-rover/article/taillight.jpg
// module id = va3D
// module chunks = 1